import { addToDataLayer } from '../utils';

type AddToBasketArgs = {
  name: string;
  sku: string;
  price: number;
  brand: string;
  category: string;
  dimension6: string;
  quantity: number;
  productId: string;
  currency: string;
  promocode?: string;
};

export const addToBasket = ({
  productId,
  name,
  sku,
  price,
  brand,
  category,
  dimension6,
  quantity,
  currency,
  promocode,
}: AddToBasketArgs) => {
  const id = promocode ? `${sku} ${promocode}` : sku;

  const product = {
    event: 'addToCart',
    ecommerce: {
      add: {
        products: [
          {
            name,
            id,
            price,
            brand,
            category,
            quantity,
            metric6: 0,
            br_prod_id: productId,
            dimension6,
            currency,
          },
        ],
      },
    },
  };

  addToDataLayer({ ecommerce: null }); // clear before every add to cart
  addToDataLayer(product);
};
